<template>
    <div class="panel white_bg">
        <div class="inner paddingH16">

            <form>

                <div class="productList font14r">
                    <label class="block item flexLayout" :class="{ active : checkedIds===dataItem.id }"
                           v-for="dataItem in dataList" :key="dataItem.id">
                        <div style="width: 46px">
                            <input type="checkbox" name="id" :value="dataItem.id" class="modernCheckbox"
                                v-model="checkedIds" @change="onChangeProduct"/>
                        </div>
                        <div class="flexItem">
                            {{dataItem.productName}}
                        </div>
                        <div style="width: 60px;">
                            ￥{{dataItem.price}}
                        </div>
                    </label>
                </div>

            </form>

        </div>

    </div><!-- end .module -->
</template>

<script>
import modulePart from '@comp/part/modulePart';

// config
import appConfig from '@/appConfig';

// util
import numberHelper     from "@/util/numberHelper";
import arrayHelper      from "@/util/arrayHelper";
import dataMixedUtils   from "@/util/dataMixedUtils";
import appHelper from "@util/appHelper";

const config = {
    apiConfig : {
        list : {
            url : 'portal/v2/distribution/agency/product/list',
            params : {
                productType : 1
            },
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            totalPath : 'data.total',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '《保育员》专题网课',
        '《心理咨询师》专题网课',
        '《托育指导师》专题网课',
        '福利三：幼师体验资料包免费下载学习'
    ]
};

export default {
    name: "moduleName",
    extends : modulePart,
    components : {  },
    props : {
        productType : {
            type : String,
            default : '1'
        }
    },
    data () {
        return {
            apiConfig : config.apiConfig,

            enableDataList : true,
            // autoLoadDataList : true,
            // enableDataItem : true,
            // autoLoadDataItem : true,
            formData : {
                account: ''
            },
            checkedIds : [],

        }
    },
    methods : {
        onChangeProduct() {
            this.$emit('changeProduct', this.checkedIds);
        },
        checkAll(status) {
            if (status)
            {
                for (let i=0; i<this.dataList.length; i++)
                {
                    dataMixedUtils.array.existElement(this.dataList[i].id, this.checkedIds) ?
                        null : this.checkedIds.push(this.dataList[i].id);
                }
            }
            else
            {
                for (let i=0; i<this.dataList.length; i++)
                {
                    dataMixedUtils.array.existElement(this.dataList[i].id, this.checkedIds) ?
                        this.checkedIds = dataMixedUtils.array.removeElement(this.checkedIds, this.dataList[i].id) : null;
                }
            }
            this.$emit('changeProduct', this.checkedIds);
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            for (let i=1; i<=8; i++)
            {
                this.dataList.push({
                    id : i,
                    productName : arrayHelper.getRandomItem(config.demoTitleList),
                    price : dataMixedUtils.number.getRandomInteger(1000),
                    createTime : new Date().getTime() - numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                });
            }
        }

        this.apiConfig.list.params.productType = this.productType;
        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>
.darkred {
    color: #BD3124;
}
.orange {
    color: #E99D42;
}
.productList {
    .item {
        margin-bottom: 6px;
        border : dashed 1px #ADAAAA;
        background: white;
        padding: 17px 0 28px;
    }
    .item:last-child {
        margin-bottom: 0;
    }
    .item.active {
        border : dashed 1px #E99D42;
        background: #F4CE98;
    }
}
</style>
